module.exports = __webpack_public_path__ + "img/hermes_04.262dc6a6.jpg";